<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">

      <page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Edit Contact Group" :menuAccess="true" :closePage="true"></page-nav-bar>

      <div class="layoutTop"/>
      <b-container fluid>
        <b-row>
          <b-col md="10" offset-md="1">
            <back-button></back-button>
            <div class="panel21 panel-default">

              <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <f7-icon fa="address-book" class="formIcon"></f7-icon>
                  {{ $t('contacts.edt_cntct_grp') }}
                </h4>
              </div>

              <b-row class="justify-content-start">
                <b-col sm="6" class="form-group">
                  <form-write-group-label-input v-model="groupName" isMandatory
                    :idLabel="$t('common.nme')" :placeholderValue="$t('common.nme')">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="3" class="form-group">
                  <label>{{ $t('contacts.my_contacts') }}</label>
                  <f7-button round
                    href="/account/addContactGroupContactList/">
                    {{ this.selected.length }} {{ $t('common.slctd') }}
                  </f7-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="form-group" v-if="Object.keys(this.selectedDebtors).length > 0">
                  {{ $t('contacts.cntcts_in_ths_grp') }}
                </b-col>
              </b-row>
              <b-row>
                <ul class=" offset-sm-1 col-sm-10 list-group"
                  v-if="Object.keys(this.selectedDebtors).length !== 0">
                  <li class="list-group-item" v-for="value in this.selectedDebtors" :key="value.id">
                    {{ value.label }}
                  </li>
                </ul>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2" offset-md="9">
            <f7-button
              class="button-action milkyBlockBlack"
              @click="changeContactGroup">
              <f7-icon fa="save"></f7-icon>
              <span>{{ $t('common.sve') }}</span>
            </f7-button>
          </b-col>
        </b-row>
      </b-container>


      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'back-button': backButton,
    'bottom-toolbar': bottomToolbar,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-nav-bar': pageNavBar
  },
  data: () => {
    return {
      contacts: [],
      contactsObject: {},
      contactSelectionList: [],
      selectedDebtors: {},
      selected: [],
      contactGroupId: '',
      groupName: ''
    }
  },
  created () {
    let that = this
    this.contacts = this.$engine.contacts.get()
    for (var i = 0; i < that.contacts.length; i++) {
      that.contactsObject[that.contacts[i].id] = that.contacts[i]
    }
    this.setContacts()

    this.contactGroupId = this.$settings.currentContactGroup.id
    this.groupName = this.$settings.currentContactGroup.label
    this.selected = this.$settings.currentContactGroup.contacts
    this.changeItem()

    that.$engine.settings.set({addContactGroupContactSelected: this.selected})

    this.$bus.$on('refresh-add-contact-group-contact-selected', (data) => {
      that.selected = data
      that.changeItem()
    })
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {
    changeItem () {
      this.selectedDebtors = {}
      for (var i = 0; i < this.selected.length; i++) {
        this.selectedDebtors[this.selected[i]] = this.contactsObject[this.selected[i]]
      }
    },
    setContacts () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id, typeContact: this.$engine.contacts.get(j).typeContact})
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    orderKeys (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })

      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }

      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    changeContactGroup () {
      let that = this
      if (that.groupName !== '' && that.selected.length > 0) {
        this.$engine.contacts.updateGroup({
          idContactGroup: this.contactGroupId,
          label: this.groupName,
          contacts: this.selected
        })
        .then(() => {
          that.$f7.modal({
            title: 'Contact modified',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.contactGroupId = ''
            that.groupName = ''
            that.selected = []
            that.$bus.$emit('refresh-cache-contacts')
            loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
        this.$f7.closeModal()
      } else {
        this.$f7.alert('', 'Data empty')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMEditContactGroup.vue?443b93f8